import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { APP_TRANSLATIONS, AppLanguage, LANGUAGE_STORAGE_KEY } from '../i18n/app-translations';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly languageSubject = new BehaviorSubject<AppLanguage>(this.readLanguage());

  readonly language$ = this.languageSubject.asObservable();

  get currentLanguage(): AppLanguage {
    return this.languageSubject.value;
  }

  setLanguage(language: AppLanguage): void {
    if (language !== 'bn' && language !== 'en') {
      return;
    }

    this.languageSubject.next(language);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
  }

  translate(key: string | null | undefined, fallback = ''): string {
    const normalizedKey = `${key ?? ''}`.trim();
    if (!normalizedKey) {
      return fallback;
    }

    const currentMap = APP_TRANSLATIONS[this.currentLanguage] ?? {};
    const fallbackMap = APP_TRANSLATIONS.en;
    return currentMap[normalizedKey] ?? fallbackMap[normalizedKey] ?? fallback;
  }

  private readLanguage(): AppLanguage {
    if (typeof localStorage === 'undefined') {
      return 'bn';
    }

    const stored = `${localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? ''}`.trim().toLowerCase();
    return stored === 'en' ? 'en' : 'bn';
  }
}
